import { createFileRoute } from '@tanstack/react-router';
import { AccountPage } from '@/features/settings/account/AccountPage';

export const Route = createFileRoute('/_auth/settings/account')({
  component: AccountPage,
});
